import React, { FC, useContext } from 'react'
import { Trans, t } from '@lingui/macro'

import { CertificationItemTypes } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import { Modal } from '../../../components/common/modal/Modal'
import { ItemModal } from './ItemModal'
import { ManageCertificationPageContext } from './ManageCertificationPage'
import { ManageCertificationPageQuery } from './ManageCertificationPage.codegen'

import './NewCertificateItemModal.less'
import { ButtonClean } from 'front-end/src/components'

export type Certification = NonNullable<
  NonNullable<ManageCertificationPageQuery['admin']>['certification']
>

interface IProps {
  show: boolean
  onClose: () => void
}

const existingItems = (
  certification: Certification,
  itemType: CertificationItemTypes
) => {
  return certification.items
    ?.filter((i) => i.item_type === itemType)
    .map((i) => i.item_id)
}

export const NewCertificateItemModal: FC<IProps> = ({ show, onClose }) => {
  const { certification, refetch } = useContext(ManageCertificationPageContext)

  const resourceItemIds = existingItems(
    certification,
    CertificationItemTypes.topic
  )
  const pathwayItemIds = existingItems(
    certification,
    CertificationItemTypes.pathway
  )
  const eventItemIds = existingItems(
    certification,
    CertificationItemTypes.event
  )

  const onSubmit = () => {
    onClose()
    refetch()
  }

  return (
    <Modal
      header={t`Add into certification`}
      show={show}
      className="AddNewCertification"
      controls={
        <ButtonClean onClick={() => onClose()}>
          <Trans>Cancel</Trans>
        </ButtonClean>
      }
    >
      <div className="choose-page">
        <ul className="page-options">
          <ItemModal
            onSubmit={onSubmit}
            itemIds={resourceItemIds || []}
            itemType={CertificationItemTypes.topic}
          />
          <ItemModal
            onSubmit={onSubmit}
            itemIds={pathwayItemIds || []}
            itemType={CertificationItemTypes.pathway}
          />
          <ItemModal
            onSubmit={onSubmit}
            itemIds={eventItemIds || []}
            itemType={CertificationItemTypes.event}
          />
        </ul>
      </div>
    </Modal>
  )
}
